import React from "react";

import { ReactComponent as Qualified } from "assets/qualified.svg";
import { Button, StyledGrid, Heading, StyledP } from "components/simple";
import { color, spacingDefaults, fontSize } from "style/constants";

const Qualify: React.FC = () => (
  <StyledGrid
    justifyContent="center"
    alignContent="center"
    alignItems="center"
    backgroundColor={color.WHITE}
    container
    direction="column"
    fillRemainingHeight
    minHeight="700px"
    wrap="nowrap"
    textAlign="center"
    padding={spacingDefaults.normal}
    itemMargin={spacingDefaults.normal}
  >
    <StyledGrid item>
      <Qualified />
    </StyledGrid>
    <StyledGrid item>
      <Heading tag="h1" fontSize={fontSize.header}>
        Congratulations!
      </Heading>
    </StyledGrid>
    <StyledGrid maxWidth="600px" mobileMarginBottom={spacingDefaults.normal}>
      <StyledP textAlign="center">
        You qualify for the BrainHealth Project. You have one more step to
        complete enrollment.
      </StyledP>
    </StyledGrid>
    <StyledGrid item>
      <Button wide href={"/consent/consent-video"}>
        Continue
      </Button>
    </StyledGrid>
  </StyledGrid>
);

export default Qualify;
